module.exports = __webpack_public_path__ + "img/1081218227.fb69cff9.jpg";